module.exports = __webpack_public_path__ + "static/uliege_logo_normal-1eada79f84b206bca9bb5c3ca3ab3743.png";